import { render, staticRenderFns } from "./EntrustDetails.vue?vue&type=template&id=73ba6d32&scoped=true&"
import script from "./EntrustDetails.vue?vue&type=script&lang=js&"
export * from "./EntrustDetails.vue?vue&type=script&lang=js&"
import style0 from "./EntrustDetails.vue?vue&type=style&index=0&id=73ba6d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ba6d32",
  null
  
)

export default component.exports